import { mediasFields } from './composer'

export const getSetBySlug = () => {
  return `query getSetBySlug($slug: String!,$limit: Int = 10, $offset: Int = 0) {
  setBySlug(slug: $slug,limit: $limit, offset: $offset) {
    title
    summary
    summaryEn
    total
    medias {
      ${mediasFields}
cardImage {
  url
  isIcon
  alt
  centered
}
cardDate
cardDescription
    }
  }
  }`
}
